// Single module-scope listener for `beforeinstallprompt`, captured once as
// soon as this module first loads rather than per-component. The event only
// fires once per page load - if each component that wants it (the global
// InstallPrompt banner, an inline callout on some other page) attached its
// own listener on mount, whichever one mounts after a client-side route
// change would simply miss an event that already fired and get stuck
// showing its no-native-prompt fallback, even on a browser that supports it.

let snapshot = { deferredPrompt: null, installed: false };
const listeners = new Set();

const setSnapshot = (next) => {
  snapshot = { ...snapshot, ...next };
  listeners.forEach((listener) => listener());
};

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    setSnapshot({ deferredPrompt: event });
  });
  window.addEventListener("appinstalled", () => {
    setSnapshot({ deferredPrompt: null, installed: true });
  });
}

export const subscribePwaInstall = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

// Stable object reference between calls unless state actually changed -
// required so useSyncExternalStore doesn't re-render in a loop.
export const getPwaInstallSnapshot = () => snapshot;

export const promptPwaInstall = async () => {
  const { deferredPrompt } = snapshot;
  if (!deferredPrompt) return null;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  setSnapshot({ deferredPrompt: null });
  return choice;
};
